import { Link, useParams } from 'react-router';
import { getKeeperDossier, listAvailableDossierSlugs } from '../data/keeperDossiers';
import KeeperResearchView from './KeeperResearchView';

export default function KeeperResearchManager() {
  const { slug } = useParams();
  const dossier = getKeeperDossier(slug);

  if (!dossier) {
    const available = listAvailableDossierSlugs();
    return (
      <section className="px-6 md:px-14 py-20">
        <h1 className="font-display text-4xl md:text-6xl font-black uppercase">No dossier yet.</h1>
        <p className="mt-4 text-ink-secondary italic max-w-2xl">
          A current keeper research dossier has not been published for "{slug}" yet.
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          {available.map((s) => (
            <Link
              key={s}
              to={`/keeper-vault/research/${s}`}
              className="inline-flex border border-accent-gold px-4 py-3 text-[11px] font-extrabold tracking-[0.22em] text-accent-gold uppercase hover:bg-accent-gold hover:text-bg-deep transition-colors"
            >
              {s} dossier
            </Link>
          ))}
          <Link
            to="/keeper-vault"
            className="inline-flex border border-border px-4 py-3 text-[11px] font-extrabold tracking-[0.22em] text-ink-secondary uppercase hover:border-accent-gold hover:text-accent-gold transition-colors"
          >
            Back to vault
          </Link>
        </div>
      </section>
    );
  }

  return <KeeperResearchView dossier={dossier} />;
}
